import { stats } from "../data/siteContent";

export default function HomeStats() {
  return (
    <section className="ags-stats-section">
      <div className="container">
        <div className="ags-surface-panel ags-stats-panel" data-aos="fade-up">
          <div className="row g-4">
            {stats.map((item, index) => (
              <div className="col-md-6 col-xl-3" key={item.label} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="ags-stat-card h-100">
                  <div className="ags-stat-value">{item.value}</div>
                  <p className="mNoMargin text-muted">{item.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
